<template>
  <div class="nav-search">
    <div class="nav-search-header">
      <form autocomplete="off" @submit.prevent="()=>{}">
        <vs-input ref="navSearch" class="nav-search-keyword w-full" v-model="text"/>
      </form>
      <span v-if="!text" class="nav-placeholder">메뉴검색</span>
      <div class="icon">
        <feather-icon icon="SearchIcon"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    text(value) {
      this.$emit('search', value)
    }
  },
  data() {
    return {
      text: ''
    }
  },
  created() {
    this.text = this.$store.state.menu.search;
  }
}
</script>

<style scoped lang="scss">
.nav-search {
  padding: 0 20px;
}
.nav-search-header {
  position: relative;

  .nav-placeholder {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.7rem;
    color: #999999;
    font-size: 14px;
  }

  .icon {
    display: flex;
    align-items: center;


    width: 28px;


    position: absolute;
    right: 0 ;
    top: 0;
    bottom: 0;

    svg {
      color: #999999;
    }
  }
}
</style>

<style lang="scss">
.nav-search-keyword {
  .vs-input--input {
    padding: .7rem 40px .7rem 0.7rem !important;
    font-weight: 600;
    color: #3c3c3c;
  }
  .vs-input--placeholder {
    font-size: 14px;
    color: #999999;
  }
}
</style>
